import type { Arrangement, EventType } from '@/types';
import { EVENT_TYPE_CONFIG } from '@/lib/eventTypes';
import { supabase } from '@/lib/supabase';

export function defaultGroups(eventType: EventType, partner1?: string, partner2?: string): string[] {
  if ((eventType === 'bryllup' || eventType === 'forlovelse') && partner1 && partner2) {
    const p1 = partner1.split(' ')[0];
    const p2 = partner2.split(' ')[0];
    return ['Paret', `Familie - ${p1}`, `Familie - ${p2}`, 'Felles venner', 'Kollegaer'];
  }
  return [...EVENT_TYPE_CONFIG[eventType].defaultGuestGroups];
}

export function storedGroups(arrangement: Pick<Arrangement, 'settings'> | null): string[] | undefined {
  const list = arrangement?.settings?.guest_groups;
  return Array.isArray(list) ? (list as string[]) : undefined;
}

export function baseGroups(arrangement: Arrangement | null): string[] {
  if (!arrangement) return [];
  return storedGroups(arrangement) ?? defaultGroups(arrangement.eventType, arrangement.partner1, arrangement.partner2);
}

export function partnerGroupRenames(prev: Arrangement, next: Arrangement): [string, string][] {
  if (prev.partner1 === next.partner1 && prev.partner2 === next.partner2) return [];
  const before = defaultGroups(prev.eventType, prev.partner1, prev.partner2);
  const after = defaultGroups(next.eventType, next.partner1, next.partner2);
  return before.map((from, i) => [from, after[i]] as [string, string]).filter(([from, to]) => to && from !== to);
}

export async function renameGuestGroupInDb(arrangementId: string, from: string, to: string | null) {
  const { error } = await supabase
    .from('guests')
    .update({ grp: to })
    .eq('arrangement_id', arrangementId)
    .eq('grp', from);
  return error;
}
